import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DetailsState } from './types';

const initialState: DetailsState = {
  status: {},
  error: '',
  details: {},
  referredModules: [],
  trails: {
    list: [],
    meta: {},
  },
  hightlights: {},
  auditHistory: [],
  history: [],
  relatedRecords: {},
};

export const details360slice = createSlice({
  name: 'details360',
  initialState,
  reducers: {
    setStatus(
      state: DetailsState,
      action: PayloadAction<DetailsState['status']>,
    ) {
      state.status = {
        ...state.status,
        ...action.payload,
      };
    },
    setError(
      state: DetailsState,
      action: PayloadAction<DetailsState['error']>,
    ) {
      state.error = action.payload;
    },
    setTrails(state: DetailsState, action: PayloadAction<{ list; meta }>) {
      state.trails = action.payload;
    },
    setReferredModules(
      state: DetailsState,
      action: PayloadAction<DetailsState['referredModules']>,
    ) {
      state.referredModules = action.payload;
    },
    setMyActions(
      state: DetailsState,
      action: PayloadAction<DetailsState['hightlights']['myActions']>,
    ) {
      state.hightlights.myActions = action.payload;
    },
    setLastEngagement(
      state: DetailsState,
      action: PayloadAction<DetailsState['hightlights']['lastEngagement']>,
    ) {
      state.hightlights.lastEngagement = action.payload;
    },
    setAuditHistory(
      state: DetailsState,
      action: PayloadAction<DetailsState['auditHistory']>,
    ) {
      state.auditHistory = action.payload;
    },
    setHistory(
      state: DetailsState,
      action: PayloadAction<DetailsState['history']>,
    ) {
      state.history = action.payload;
    },
    setRelatedRecords(
      state: DetailsState,
      action: PayloadAction<DetailsState['relatedRecords']>,
    ) {
      state.relatedRecords = {
        ...state.relatedRecords,
        ...action.payload,
      };
    },
    clearDetailsState(state: DetailsState) {
      state.auditHistory = [];
      state.details = {};
      state.hightlights = {};
      state.referredModules = [];
      state.relatedRecords = {};
      state.status = {};
      state.trails = [];
    },
  },
});

export const {
  setStatus,
  setTrails,
  setError,
  setAuditHistory,
  setHistory,
  setLastEngagement,
  setMyActions,
  setReferredModules,
  setRelatedRecords,
  clearDetailsState,
} = details360slice.actions;

const reducer = { details360: details360slice.reducer };

export default reducer;
